import React from 'react';
import Icon from './Icon';
import ScrollAnimate from './ScrollAnimate';

const FrontPageTechnology = () => (
  <section className="front-page--section">
    <div>
      <h1 className="front-page--title front-page--title-divider">Technology</h1>
      <p>Here is a partial list of technologies I am skilled with.</p>
    </div>
    <div className="front-page--section-block-container">
      <ScrollAnimate
        animateIn="animation_fadeInUp"
        animateOnce
        classes="front-page--section-block front-page--section-block-third"
      >
        <Icon
          type="IconMobile"
          className="front-page--icon-wrap"
          iconClassName="front-page--icon"
          height="80"
          width="80"
        />
        <h2 className="front-page--subtitle">Browser</h2>
        <ul>
          <li>HTML / CSS / Sass / Less</li>
          <li>JavaScript / ES2015 / jQuery</li>
          <li>React/Redux</li>
          <li>AJAX / JSON / XML</li>
        </ul>
      </ScrollAnimate>
      <ScrollAnimate
        animateIn="animation_fadeInUp"
        animateOnce
        classes="front-page--section-block front-page--section-block-third"
      >
        <Icon
          type="IconTerminal"
          className="front-page--icon-wrap"
          iconClassName="front-page--icon"
          height="80"
          width="80"
        />

        <h2 className="front-page--subtitle">Languages</h2>
        <ul>
          <li>JavaScript</li>
          <li>Python</li>
          <li>PHP</li>
          <li>C#</li>
          <li>PL/SQL</li>
          <li>T-SQL</li>
        </ul>
      </ScrollAnimate>
      <ScrollAnimate
        animateIn="animation_fadeInUp"
        animateOnce
        classes="front-page--section-block front-page--section-block-third"
      >
        <Icon
          type="IconPackage"
          className="front-page--icon-wrap"
          iconClassName="front-page--icon"
          height="80"
          width="80"
        />

        <h2 className="front-page--subtitle">Frameworks / CMS</h2>
        <ul>
          <li>Node.js / Express</li>
          <li>Django</li>
          <li>Laravel</li>
          <li>Yii</li>
          <li>ASP.NET MVC</li>
          <li>&nbsp;</li>
          <li>WordPress</li>
        </ul>
      </ScrollAnimate>
      <ScrollAnimate
        animateIn="animation_fadeInUp"
        animateOnce
        classes="front-page--section-block front-page--section-block-third"
      >
        <Icon
          type="IconDatabase"
          className="front-page--icon-wrap"
          iconClassName="front-page--icon"
          height="80"
          width="80"
        />

        <h2 className="front-page--subtitle">Data</h2>
        <ul>
          <li>Oracle</li>
          <li>MS SQL Server</li>
          <li>PostgreSQL</li>
          <li>MySQL / MariaDB</li>
          <li>MongoDB</li>
          <li>Redis</li>
          <li>Memcached</li>
        </ul>
      </ScrollAnimate>
      <ScrollAnimate
        animateIn="animation_fadeInUp"
        animateOnce
        classes="front-page--section-block front-page--section-block-third"
      >
        <Icon
          type="IconStack"
          className="front-page--icon-wrap"
          iconClassName="front-page--icon"
          height="80"
          width="80"
        />

        <h2 className="front-page--subtitle">Server</h2>
        <ul>
          <li>Nginx</li>
          <li>IIS</li>
          <li>Apache</li>
          <li>Gunicorn</li>
        </ul>
      </ScrollAnimate>
      <ScrollAnimate
        animateIn="animation_fadeInUp"
        animateOnce
        classes="front-page--section-block front-page--section-block-third"
      >
        <Icon
          type="IconMeter"
          className="front-page--icon-wrap"
          iconClassName="front-page--icon"
          height="80"
          width="80"
        />

        <h2 className="front-page--subtitle">Infrastructure</h2>
        <ul>
          <li>AWS</li>
          <li>Azure</li>
          <li>Heroku</li>
          <li>Digital Ocean</li>
          <li>Docker</li>
          <li>Ansible</li>
          <li>Vagrant</li>
        </ul>
      </ScrollAnimate>
    </div>
  </section>
);

export default FrontPageTechnology;



// WEBPACK FOOTER //
// ./src/components/FrontPageTechnology.js